<template>
  <v-snackbar
      v-model="display"
      :color="type"
      :timeout="timeout"
      :top="!isMobile"
      :bottom="isMobile"
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="onDismiss()"
      >
        {{ $t('alerts.snackbar.close') }}
      </v-btn>
    </v-snackbar>
</template>

<script>
import { isMobile } from '../../mixins/responsive.mixins';

export default {
  name: 'error-snack',
  mixins: [isMobile],
  components: {},
  props: {
    globalMessage: {
      type: Object,
      required: true,
    },
    timeout: {
      type: Number,
      default: -1,
    },
    type: {
      type: String,
      requried: true,
    },
  },
  data() {
    return {
      dismiss: false,
      show: false,
    };
  },
  mounted() {
    this.show = true;
  },
  computed: {
    display() {
      return this.globalMessage.message && this.show && !this.dismiss;
    },
    message() {
      if (this.globalMessage.code && this.$te(`apiErrors.${this.globalMessage.code}`)) {
        return this.$t(`apiErrors.${this.globalMessage.code}`);
      }

      return this.$t(this.globalMessage.message);
    },
  },
  methods: {
    onDismiss() {
      this.$emit('dismissed', this.globalMessage);
      this.dismiss = true;
    },
  },
};
</script>
<style>
</style>
